import { get, transformFormItems, numberDiv, numberMul } from '../../../utils/index'
import { useTemplate } from '../../../hooks/index'
import { shallowRef, watch, getCurrentInstance, computed } from 'vue'
export function useItems({ formItems, formItemsUrl, formItemsCode, compileSource }) {
  const { compileData, getTemplateData } = useTemplate()
  const { proxy } = getCurrentInstance()
  const strategy = computed(() => proxy.$store?.state.strategy?.strategy ?? {})
  const formItemsList = shallowRef([])
  //配置的表单信息
  const formProp = shallowRef({})
  //配置的表单属性
  const formProperty = computed(() => {
    return Object.assign(
      {
        inline: true, //boolean
        labelPosition: 'top', //string,right/left/top
        labelWidth: undefined, //string,表单域标签的宽度，如：'100px'
        labelSuffix: undefined, //string,表单域标签的后缀
        hideRequiredAsterisk: false, //boolean,是否隐藏必填字段的标签旁边的红色星号
        showMessage: true, //boolean,是否显示校验错误信息
        inlineMessage: false, //boolean,是否以行内形式展示校验信息
        colNum: undefined, //number，一行展示多少列, 如: 5
        colWidth: undefined, //number，一列显示的宽度，如: 200; 当colNum和colWidth同时有值时colNum优先级更高
        formGroup: true, //Boolean, 是否根据配置的formGroup组件进行分组
        style: null, //Object, 表单自定义样式
      },
      formProp.value.property
    )
  })
  //计算formItem标签的基本宽度
  const formItemWidth = computed(() => {
    //表单未开启行内模式时，不计算
    if (!formProperty.value.inline) {
      return null
    }
    if (formProperty.value.colNum) {
      return Math.floor(numberMul(numberDiv(1, formProperty.value.colNum, 6), 10000)) / 10000
    }
    return formProperty.value.colWidth
  })
  //获取配置
  const getList = async () => {
    if (formItemsCode.value) {
      const [resData] = await get(`${formItemsUrl.value}${formItemsCode.value}`)
      formProp.value = resData?.data.form ?? {}
      formItemsList.value = transformFormItems(
        resData?.data.items,
        strategy.value,
        formProperty.value.formGroup,
        {
          compileSource,
          compileData,
          getTemplateData,
        }
      )
    } else if (formItems.value) {
      formProp.value = Array.isArray(formItems.value) ? {} : formItems.value.form ?? {}
      formItemsList.value = transformFormItems(
        Array.isArray(formItems.value) ? formItems.value : formItems.value.items,
        strategy.value,
        formProperty.value.formGroup,
        {
          compileSource,
          compileData,
          getTemplateData,
        }
      )
    } else {
      console.error('未配置表单定义formItemsCode或formItems')
    }
  }
  watch([formItems, formItemsUrl, formItemsCode], getList, { immediate: true })

  return {
    formItemsList,
    formProp,
    formProperty,
    formItemWidth,
  }
}
